import React from "react";
import ProfileDetail from "./ProfileDetail";

const ProfileInfo = () => {
    return (
        <>
            <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active fs-sm" id="nav-overview-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-overview" type="button" role="tab" aria-controls="nav-overview"
                            aria-selected="true">
                        Overview
                    </button>
                    <button className="nav-link fs-sm" id="nav-settings-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-settings" type="button" role="tab" aria-controls="nav-settings"
                            aria-selected="false">
                        Settings
                    </button>
                </div>
            </nav>
            <div className="tab-content border border-top-0 p-4 rounded-bottom-2" id="nav-tabContent">
                <div className="tab-pane fade show active" id="nav-overview" role="tabpanel"
                     aria-labelledby="nav-overview-tab" tabIndex="0">
                    <ProfileDetail/>
                </div>
                <div className="tab-pane fade" id="nav-settings" role="tabpanel"
                     aria-labelledby="nav-settings-tab" tabIndex="0">
                    {/*<ProfileUpdate />*/}
                    <h6 className="text-danger fw-normal">For any profile setting modifications, please reach out to the Branch Administrator.</h6>
                </div>
            </div>
        </>
    );
}
export default ProfileInfo;
